import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../api";
import "../assets/styles/Auth.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function Login() {
  const navigate = useNavigate();
  const captchaRef = useRef(null);

  const [captcha, setCaptcha] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [form, setForm] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});

  const validate = () => {
    let err = {};

    if (!form.email) err.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(form.email))
      err.email = "Invalid email format";

    if (!form.password) err.password = "Password is required";

    if (!captcha) err.captcha = "Please verify CAPTCHA";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleLogin = async (e) => {
  e.preventDefault();

  if (!validate()) return;

  setLoading(true);

  try {
    const res = await api.login({
      ...form,
      captcha,
    });

    if (res.status === "success") {
      localStorage.setItem("user", JSON.stringify(res.user));
      localStorage.setItem("token", res.token);
      navigate("/UserDashboard");
    } else {
      alert(res.message || "Login failed");

      captchaRef.current?.reset();
      setCaptcha("");
    }
  } catch (err) {
    alert("Something went wrong.");

    captchaRef.current?.reset();
    setCaptcha("");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="auth-wrapper">
       <div className="support-banner">
         <h1>Remote Desktop Support</h1>
       </div>
      
      <form className="login-card auth-card" onSubmit={handleLogin} autoComplete="off">
        
        <h2>Login</h2>

        {/* Email */}
        <div className="form-control">
          <div className="lab"><label>Email <span className="req">*</span></label></div>
          <input
            name="email"
            value={form.email}
            onChange={(e) => {
              setForm({ ...form, email: e.target.value });
              setErrors({ ...errors, email: "" });
            }}
          />
          <span className="error">{errors.email}</span>
        </div>

        {/* Password with Eye Icon */}
        <div className="form-control">
          <div className="lab"><label>Password <span className="req">*</span></label></div>

          <div className="password-field">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={form.password}
              onChange={(e) => {
                setForm({ ...form, password: e.target.value });
                setErrors({ ...errors, password: "" });
              }}
            />

            <span
              className="eye"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>

          <span className="error">{errors.password}</span>
          
        </div>

        {/* CAPTCHA */}
        <div className="form-control full">
          <ReCAPTCHA
    ref={captchaRef}
            sitekey="6LfGasIsAAAAAGQiyk-Gp8R4DMJnYysExBm02-bw"
            onChange={(v) => {
    setCaptcha(v);
    setErrors({ ...errors, captcha: "" });
  }}
  onExpired={() => {
    setCaptcha("");
    setErrors({ ...errors, captcha: "CAPTCHA expired. Please verify again" });
  }}
/>
<span className="error">{errors.captcha}</span>
        </div>

        <button className="auth-btn" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>

        <p className="switch-text">
          Don’t have an account? <Link to="/register">Create Account</Link>
        </p>
        <p className="forgot-link">
             <Link to="/forgot-password">Forgot Password?</Link>
          </p>
      </form>
    </div>
  );
}